import { render, staticRenderFns } from "./order-manager.vue?vue&type=template&id=048e345e&scoped=true&"
import script from "./order-manager.vue?vue&type=script&lang=js&"
export * from "./order-manager.vue?vue&type=script&lang=js&"
import style0 from "./order-manager.vue?vue&type=style&index=0&id=048e345e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e345e",
  null
  
)

export default component.exports